export class Analytics {
    static fire(interaction, action_prefix, event_properties) {
        const { action, label, value, seller } = event_properties;

        window.dataLayer.push({
            "event": "click-or-view",               // Triggers our Tag in Google Tag Manager
            "action": action_prefix + action,
            "label": label,
            "value": value,
            "non_interaction_hit": !interaction,    // false for clicks, true for views
            "seller": seller.name || "",            // If the seller name is undefined use "" to keep seller selection consistent in data studio.
            "seller_id": seller.id
        });
    }

    static click(event_properties) {
        this.fire(true, "Click ", event_properties);
    }

    static view(event_properties) {
        this.fire(false, "View ", event_properties);
    }
}